export default __webpack_public_path__ + "static/media/thumbnail.98644e66.png";